/* Built In Imports */
/* External Imports */
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  chakra,
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/* Services */

/**
 * Renders the Faq component.
 *
 * @param faqSection.faqSection
 * @param {Array} faqSection - Main FAQ data.
 * @param faqSection.region
 * @param faqSection.lang
 * @param faqSection.bgColor
 * @param faqSection.color
 * @returns {ReactElement} FaqSection component.
 */
const FaqSectionV3 = ({ faqSection, region, lang, bgColor, color }) => {
  return (
    <Box
      fontFamily={lang == 'ta' ? 'MuktaMalar' : 'FedraSansStd-book'}
      fontSize="1.1rem"
      lineHeight="1.61"
      width="100%"
      mt="0"
      px="15px"
      id={faqSection?.id}
      className="faqSection"
      marginBottom={{ base: '0px', sm: '0px', lg: '-15px' }}
    >
      <Accordion
        key={nanoid()}
        allowMultiple
        m={{ base: '0 auto' }}
        width={{ base: '100%' }}
      >
        <AccordionItem border="none">
          <AccordionButton
            bgColor={bgColor || '#424786'}
            //borderRadius="3px"
            mb="2px"
            fontFamily={lang == 'ta' ? 'MuktaMalar' : 'FedraSansStd-medium'}
            fontSize={{ base: '18px', md: '20px' }}
            fontWeight={lang == 'ta' ? '600' : ''}
            border="none"
            padding="10px 30px 10px 30px"
            color={color || 'white'}
            _hover={{ bgColor: bgColor || '#424786', color: color || 'white' }}
            _focus={{ shadow: 'transparent' }}
            minHeight="74px"
            lineHeight="1.5"
          >
            <chakra.div flex="1" textAlign="left">
              {faqSection.title}
            </chakra.div>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel pb={1}>
            {faqSection?.faqs?.length
              ? faqSection.faqs.map(faq => {
                  return (
                    <FaqChildren
                      key={nanoid()}
                      faq={faq}
                      region={region}
                      lang={lang}
                    />
                  );
                })
              : null}
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
      <style>
        {`
      .commanFaqs {
        margin-top:0;
      }
      .commanFaqs div > div {
        margin-top:0;
      }
      .commanFaqs ol, .commanFaqs ul  {
          margin-left:20px;
        }
        .light-theme .faqSection .faqSectionItem .chakra-accordion__button {
          color: black;
        }
        .light-theme .faqSection .faqSectionItem .chakra-accordion__button {
          color: black;
        }
        .light-theme .commanFaqs p {
          color: black;
        }          
      `}
      </style>
      <style global jsx>
        {`
          .faq a {
            color: #cf4520;
          }
          #faqs-section-v3 button svg {
            width: 1.2em;
            height: 1.2em;
          }
          .faq span.setting:after {
            font-family: fontawesome;
            font-size: 1.6rem;
            content: '\f013';
            color: #fff;
            background: rgba(31, 41, 55, var(--tw-bg-opacity));
            border-radius: 18px;
            padding: 7px 8px 6px;
            --tw-bg-opacity: 1;
            vertical-align: middle;
          }
          .faq ul {
            padding-left: 1.5em;
          }
          .faq p {
            padding-bottom: 20px;
          }
          @media (max-width: 767px) {
            .css-fld5d2 {
              padding-bottom: 15px;
            }
          }
        `}
      </style>
    </Box>
  );
};

const FaqChildren = ({ faq, region, lang }) => {
  return (
    <AccordionItem
      key={nanoid(4)}
      borderBottomWidth="1px"
      borderBottomColor="gray.400"
      borderTop="none"
      lineHeight="1.61"
      className="faqSectionItem"
      m="0 16px"
      _last={{ borderBottom: 'none' }}
    >
      <AccordionButton
        fontFamily={lang == 'ta' ? 'MuktaMalar' : 'FedraSansStd-medium'}
        fontSize={{ base: '16px', md: '18px' }}
        fontWeight={lang == 'ta' ? '600' : ''}
        borderTop="none"
        color="#fff"
        _hover={{ background: 'none' }}
        _focus={{ shadow: 'transparent' }}
        marginBottom={'-10px'}
        height={{ base: '', sm: '', md: '80px', lg: '80px' }}
        pl={'0'}
      >
        <chakra.div
          flex="1"
          textAlign="left"
          key={nanoid(4)}
          p={{ base: '8px 0 16px 0', md: '0' }}
        >
          {faq.question}
        </chakra.div>
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel
        pb={2}
        fontSize="1.1rem"
        fontFamily={lang == 'ta' ? 'MuktaMalar' : 'FedraSansStd-book'}
        lineHeight="1.61"
        pl="0"
      >
        <Box
          display="block"
          width="100%"
          lineHeight="1.61"
          fontSize={{ lg: '18px', sm: '18px' }}
          color="#28231e"
          mb={'5px'}
        >
          <Box className="commanFaqs">
            <StructuredTextParser
              str={render(faq.answer)}
              region={region}
              lang={lang}
              color="#FFFFFF"
            />
          </Box>
        </Box>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default FaqSectionV3;
